export const orgUnit = {
  header: 'Toutes les unités ({{count}})',
  unit: 'Unité',
  name: 'Nom',
  uid: 'ID',
  approvalProcess: 'Processus d\'approbation',
  parentUnit: 'Unité parente',
  active: 'Statut',
  hint: 'Les unités représentent des départements, des magasins, des régions ou tout autre regroupement logique. Les centres de coûts et les adresses de livraison disponibles pour un acheteur lors du passage à la caisse dépendent de son unité.',
  details: {
    title: 'Détails de l\'unité',
    subtitle: 'Unité : {{ item.name }}',
    hint: 'Les unités représentent des départements, des magasins, des régions ou tout autre regroupement logique. La désactivation d\'une unité désactive tous ses enfants, y compris les sous-unités, les utilisateurs, les approbateurs et les centres de coûts. Les unités désactivées ne peuvent pas être modifiées.',
  },
  edit: {
    title: 'Modifier l\'unité',
    subtitle: 'Unité : {{ item.name }}',
  },
  create: {
    title: 'Créer une unité',
    subtitle: '',
  },
  messages: {
    deactivateTitle: 'Désactiver cette unité?',
    deactivate: 'La désactivation d\'une unité a des répercussions importantes sur votre organisation. TOUTES les sous-unités, utilisateurs, budgets et centres de coûts de l\'unité seront également désactivés.',
    confirmEnabled: 'Unité {{item.name}} activée avec succès',
    confirmDisabled: 'Unité {{item.name}} désactivée avec succès',
    update: 'Unité {{ item.name }} mise à jour avec succès',
    create: 'Unité {{ item.name }} créée avec succès',
  },
  info: {
    disabledEdit: 'Activez l\'unité pour permettre la modification.',
    disabledEnable: 'L\'unité parente doit être activée avant que cette unité puisse être activée.',
    disabledDisable: 'L\'unité racine ne peut pas être désactivée.',
  },
  links: {
    units: 'Sous-unités',
    users: 'Utilisateurs',
    approvers: 'Approbateurs',
    shippingAddresses: 'Adresses de livraison',
    costCenters: 'Centres de coûts',
  },
  tree: {
    expandAll: 'Tout développer',
    collapseAll: 'Tout réduire',
    expand: 'Développer',
    collapse: 'Réduire',
  },
  children: {
    create: {
      title: 'Créer une sous-unité',
      subtitle: '',
    },
    messages: {
      create: 'Unité {{ item.name }} créée avec succès',
    },
  },
  costCenters: {
    create: {
      title: 'Créer un centre de coûts',
      subtitle: '',
    },
  },
  form: {
    parentOrgUnit: 'Unité d\'affaires parente',
    create: 'Créer une unité',
    parentOrgUnitNotes: 'Cette unité est l\'unité de niveau supérieur de votre organisation. Elle ne peut pas être assignée à une autre unité.',
  },
  users: {
    header: 'Utilisateurs dans {{code}}',
    changeUserRoles: 'Modifier les rôles des utilisateurs',
    newUser: 'Nouvel utilisateur',
  },
  assignRoles: {
    header: 'Gérer les rôles dans {{code}}',
    instructions: {
      check: 'Pour assigner un rôle à un utilisateur, cochez la case du rôle.',
      uncheck: 'Pour supprimer un rôle, décochez la case du rôle.',
      changes: 'Les modifications sont sauvegardées automatiquement.',
    },
  },
  approvers: {
    header: 'Approbateurs dans {{code}}',
    assign: 'Gérer les approbateurs',
    new: 'Nouvel approbateur',
  },
  assignApprovers: {
    header: 'Gérer les approbateurs dans {{code}}',
    instructions: {
      check: 'Pour assigner un approbateur à cette unité, cochez la case de l\'utilisateur.',
      uncheck: 'Pour supprimer un approbateur, décochez la case de l\'utilisateur.',
      changes: 'Les modifications sont sauvegardées automatiquement.',
    },
    hint: 'Les utilisateurs affichés dans la liste des approbateurs ont des privilèges d\'approbation pour les acheteurs de cette unité et des sous-unités.',
  },
  breadcrumbs: {
    list: 'Toutes les unités',
    details: '{{name}}',
    children: 'Sous-unités',
    users: 'Utilisateurs',
    approvers: 'Approbateurs',
    addresses: 'Adresses de livraison',
    addressDetails: '{{formattedAddress}}',
    costCenters: 'Centres de coûts',
  },
};

export const orgUnitChildren = {
  title: 'Sous-unités',
  subtitle: 'Unité : {{item.name}}',
  info: {
    disabledCreate: 'Impossible de créer une sous-unité pour une unité désactivée.',
  },
  hint: 'Les unités représentent des départements, des magasins, des régions ou tout autre regroupement logique.',
};

export const orgUnitAssignedRoles = {
  header: 'Gérer les rôles dans {{code}}',
  name: 'Nom',
  email: 'Courriel',
  roles: 'Rôles',
  roleCustomer: 'Client',
  roleApprover: 'Approbateur',
  roleManager: 'Gestionnaire',
  roleAdministrator: 'Administrateur',
};

export const orgUnitApprovers = {
  title: 'Gérer les approbateurs',
  subtitle: 'Unité : {{item.name}}',
  assigned: 'Utilisateur {{item.name}} assigné avec succès',
  unassigned: 'Utilisateur {{item.name}} désassigné avec succès',
};

export const orgUnitAssignedApprovers = {
  title: 'Approbateurs assignés',
  subtitle: 'Unité : {{item.name}}',
  assigned: 'Utilisateur {{item.name}} assigné avec succès',
  unassigned: 'Utilisateur {{item.name}} désassigné avec succès',
  hint: 'Les utilisateurs affichés dans la liste des approbateurs ont des privilèges d\'approbation pour les acheteurs de cette unité et des sous-unités.',
};

export const orgUnitAssignedUsers = {
  title: 'Utilisateurs assignés',
  subtitle: 'Unité : {{item.name}}',
};

export const orgUnitUsers = {
  title: 'Utilisateurs assignés',
  subtitle: 'Unité : {{item.name}}',
  info: {
    disabledCreate: 'Impossible de créer un utilisateur pour une unité désactivée.',
  },
  hint: 'Les utilisateurs sont les acheteurs, approbateurs, gestionnaires et administrateurs de votre organisation.',
};

export const orgUnitUserRoles = {
  title: 'Rôles et droits des utilisateurs',
  subtitle: 'Utilisateur : {{item.name}}',
  messages: {
    rolesUpdated: 'Rôles mis à jour avec succès pour {{item.name}}',
  },
};

export const orgUnitCostCenters = {
  title: 'Centres de coûts assignés',
  subtitle: 'Unité : {{item.name}}',
  info: {
    disabledCreate: 'Impossible de créer un centre de coûts pour une unité désactivée.',
  },
  hint: 'Toutes les commandes passées par le compte d\'achat de votre organisation sont liées à un centre de coûts à des fins de suivi.',
};

export const orgUnitAddress = {
  title: 'Adresses de livraison',
  subtitle: 'Unité : {{item.name}}',
  country: 'Pays / Région',
  titles: 'Titre',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  formattedAddress: 'Adresse',
  address1: 'Adresse',
  address2: '2e adresse (facultatif)',
  city: 'Ville',
  state: 'État/Province',
  zipCode: 'Code postal',
  phoneNumber: 'Numéro de téléphone (facultatif)',
  streetAddress: 'Adresse municipale',
  aptSuite: 'App., bureau',
  selectOne: 'Sélectionner...',
  hint: 'Lors du passage à la caisse, les adresses de livraison disponibles pour l\'acheteur dépendent de l\'unité du centre de coûts choisi.',
  details: {
    title: 'Détails de l\'adresse',
    subtitle: 'Unité : {{item.name}}',
  },
  edit: {
    title: 'Modifier l\'adresse',
  },
  create: {
    title: 'Créer une adresse',
  },
  form: {
    subtitle: 'Unité : {{item.name}}',
  },
  messages: {
    create: 'Adresse {{ item.firstName }} {{ item.lastName }} créée avec succès',
    update: 'Adresse {{ item.firstName }} {{ item.lastName }} mise à jour avec succès',
    delete: 'L\'adresse ne peut pas être récupérée. Les commandes existantes ne sont pas affectées.',
    deleteTitle: 'Supprimer cette adresse?',
    deleted: 'Adresse {{ item.firstName }} {{ item.lastName }} supprimée avec succès',
  },
};
